<telxl-panel [hover]="true" cardClass="mt-2" bodyClass="pt-1 pb-1">
    <ng-template #cardBody>
        <div class="d-flex align-items-center">
            <div
                class="left"
                tabindex="0"
                (click)="preview()"
                (keypress)="preview()"
                [style.cursor]="canPreview() ? 'pointer' : null"
            >
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex" style="min-width: 0">
                        <span [style.width.px]="25" class="me-1">
                            <i class="fa-light" [ngClass]="fileType()"></i>
                        </span>
                        <span class="text-truncate" style="min-width: 0">
                            {{ file().name }}
                        </span>
                    </div>
                </div>
            </div>
            @if (canDownload()) {
                <div class="right">
                    <i
                        class="fa-light fa-download download"
                        tabindex="1"
                        (click)="download()"
                        (keypress)="download()"
                    ></i>
                </div>
            }
        </div>
    </ng-template>
</telxl-panel>
